<div class="sales-assistant">
  <div
    class="sales-assistants-container"
    *ngIf="salesAssistants$ | async as salesAssistants"
  >
    <div class="sales-assistants" *ngIf="salesAssistants.length">
      <!-- *ngIf="salesAssistants" -->
      <div class="assistants" *ngFor="let assistant of salesAssistants">
        <div class="assistants-row">
          <span class="assistant-label">{{
            'label.Assistant' | translate
          }}</span>
          <span class="assistant-name">{{ assistant.fullName }}</span>
          <a (click)="onRemoveAssistant(assistant.portfolioSalesAssistantId)"
            ><svg-icon src="assets/img/remove-assistant.svg"></svg-icon
          ></a>
        </div>
      </div>
    </div>
  </div>
  <div class="account-manager">
    <span>{{ 'label.AccountAssistant' | translate }}: </span>
    <select name="accountManagers" [(ngModel)]="selectedAssistantId">
      <option [ngValue]="null"></option>
      <option
        *ngFor="let item of accountManagers$ | async"
        [ngValue]="item?.adminId"
      >
        {{ item?.fullName }}
      </option>
    </select>
    <button
      [disabled]="!selectedAssistantId"
      (click)="onUpdateSalesAssistantClick()"
    >
      <svg-icon src="assets/img/add-assistant.svg"></svg-icon>
    </button>
  </div>
</div>
